// disOS profile: who's signed in, firm details for reports, and sign out.
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/authStore';
import { usePubBody } from './pubBody';
import './public.css';

export function Profile() {
  usePubBody();
  const nav = useNavigate();
  const user = useAuth((s) => s.user);
  const logout = useAuth((s) => s.logout);
  const firm = useAuth((s) => s.firm);
  const saveFirm = useAuth((s) => s.saveFirm);
  const [busy, setBusy] = useState(false);
  const [name, setName] = useState(firm.name ?? '');
  const [line1, setLine1] = useState(firm.line1 ?? '');
  const [line2, setLine2] = useState(firm.line2 ?? '');
  const [firmState, setFirmState] = useState<'idle' | 'saving' | 'saved'>('idle');
  const dirty = name !== (firm.name ?? '') || line1 !== (firm.line1 ?? '') || line2 !== (firm.line2 ?? '');

  async function saveFirmDetails() {
    setFirmState('saving');
    try { await saveFirm({ ...firm, name: name.trim(), line1: line1.trim(), line2: line2.trim() }); setFirmState('saved'); }
    catch { setFirmState('idle'); }
  }

  async function signOut() {
    setBusy(true);
    await logout();
    nav('/', { replace: true });
  }

  const initial = (user?.email ?? '?').charAt(0).toUpperCase();
  return (
    <div className="pub">
      <div className="profwrap">
        <Link className="back" to="/app">
          <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M11 6l-6 6 6 6" /></svg>
          Back to workspace
        </Link>
        <h1>Your account</h1>
        <p className="sub">Manage how you sign in to disOS.</p>

        <div className="profrow">
          <div className="avatar">{initial}</div>
          <div className="who">
            <div className="lbl">Signed in as</div>
            <div className="val">{user?.email ?? '—'}</div>
          </div>
        </div>

        <div className="firmbox">
          <div className="lbl">Firm details on reports</div>
          <p className="firmhint">Shown in the footer of every report you print. Leave blank for no footer.</p>
          <label className="firmfield"><span>Firm name</span>
            <input value={name} onChange={(e) => { setName(e.target.value); setFirmState('idle'); }} placeholder="e.g. Rivera Family Law, APC" /></label>
          <label className="firmfield"><span>Address line</span>
            <input value={line1} onChange={(e) => { setLine1(e.target.value); setFirmState('idle'); }} placeholder="e.g. 100 Main St, Suite 200, San José CA 95113" /></label>
          <label className="firmfield"><span>Contact line</span>
            <input value={line2} onChange={(e) => { setLine2(e.target.value); setFirmState('idle'); }} placeholder="e.g. (408) 555-0100 · intake@riverafamilylaw.com · Bar #123456" /></label>
          <div className="firmactions">
            <button className="btn" type="button" onClick={saveFirmDetails} disabled={firmState === 'saving' || !dirty}>
              {firmState === 'saving' ? 'Saving…' : firmState === 'saved' && !dirty ? 'Saved ✓' : 'Save firm details'}
            </button>
          </div>
        </div>

        <div className="profrow actions">
          <div className="who">
            <div className="lbl">Session</div>
            <div className="val">Sign out of this browser</div>
          </div>
          <button className="btn danger" type="button" onClick={signOut} disabled={busy}>{busy ? 'Signing out…' : 'Sign out'}</button>
        </div>
      </div>
    </div>
  );
}
